import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";
import { getIdioma } from "../utils/variablesLocales";

export class apiPrecio {
  baseApi = ENTORNO.BASE_API;

  async obtener() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Precio_ObtenerTodas}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async actualizar(Id, Localidad, PrecioPorKm, Moneda, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Precio_Actualizar}/${Id}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Localidad: Localidad,
          PrecioPorKm: PrecioPorKm,
          Moneda: Moneda,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async nuevo(Localidad, PrecioPorKm, Moneda, Activo) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Precio_Nuevo}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Localidad: Localidad,
          PrecioPorKm: PrecioPorKm,
          Moneda: Moneda,
          Activo: Activo,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async borrar(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Precio_Borrar}/${Id}`;

      const parametros = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async obtenerPrecioBase(Localidad, DistanciaEnKms) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Precio_ObtenerPrecioBase}`;

      const body = {
        Localidad: Localidad,
        DistanciaEnKms: DistanciaEnKms,
        Idioma: getIdioma(),
      };

      const respuesta = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(body),
      });

      const resultado = await respuesta.json();

      return resultado;
    } catch (error) {
      throw error;
    }
  }
}
